module.exports = __webpack_public_path__ + "static/media/conffeti-end-game-static.f37ec2a3.png";